import React from 'react'

const MoloLogo = (props) => (
  <svg
    width="51"
    height="50"
    viewBox="0 0 51 50"
    fill="none"
    xmlns="https://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3635_34119)">
      <path
        d="M44.0293 40.8177C44.6614 38.8764 45 36.811 45 34.6665C45 23.6168 36.0497 14.6665 25 14.6665C13.9503 14.6665 5 23.6168 5 34.6665C5 36.811 5.34989 38.8764 5.97065 40.8177H44.0181H44.0293Z"
        fill="url(#paint0_radial_3635_34119)"
      />
      <path
        d="M44.0293 40.8177C44.6614 38.8764 45 36.811 45 34.6665C45 23.6168 36.0497 14.6665 25 14.6665C13.9503 14.6665 5 23.6168 5 34.6665C5 36.811 5.34989 38.8764 5.97065 40.8177H44.0181H44.0293Z"
        fill="url(#paint1_radial_3635_34119)"
      />
      <path
        d="M23.6903 17.1949C18.3855 17.6012 13.758 20.4003 10.8799 24.5312L13.1937 26.1452C15.5526 22.7366 19.3449 20.4003 23.6903 20.0053V17.1836V17.1949Z"
        fill="white"
      />
      <path
        d="M12.0086 28.2332L9.6723 26.5967C8.49849 28.9217 7.82129 31.5402 7.82129 34.3168C7.82129 34.8247 7.84386 35.3326 7.88901 35.8292C7.95673 36.5628 8.56621 37.1159 9.28856 37.1159C9.3337 37.1159 9.37885 37.1159 9.41271 37.1159C10.1915 37.0481 10.7558 36.3597 10.6881 35.5809C10.6542 35.1633 10.6317 34.7457 10.6317 34.3168C10.6317 32.1384 11.1283 30.0843 11.9974 28.2332H12.0086Z"
        fill="white"
      />
      <path
        d="M39.1427 24.5764C36.2307 20.3664 31.4903 17.5222 26.084 17.1836V20.0053C30.5422 20.3439 34.4361 22.7141 36.8402 26.1904L39.154 24.5764H39.1427Z"
        fill="white"
      />
      <path
        d="M40.3608 26.6529L38.0244 28.2895C38.8822 30.1292 39.3675 32.1608 39.3675 34.3165C39.3675 34.7342 39.345 35.163 39.3111 35.5807C39.2434 36.3594 39.819 37.0366 40.5865 37.1044C41.3653 37.1721 42.0425 36.5965 42.1215 35.8177C42.1666 35.3098 42.1892 34.8132 42.1892 34.3053C42.1892 31.5513 41.5233 28.9441 40.3608 26.6416V26.6529Z"
        fill="white"
      />
      <path
        d="M27.765 38.2217C26.3429 39.926 23.9275 40.242 22.37 38.9441C20.8124 37.6461 20.6883 35.2082 22.1104 33.5039C23.0697 32.3639 34.4129 21.7432 38.6679 18.0976C39.4467 17.4316 40.4061 18.2217 39.8869 19.1134C37.0652 23.9553 28.7244 37.0818 27.7763 38.2217H27.765Z"
        fill="#3300FF"
      />
      <path
        d="M24.7851 38.0638C25.9133 38.0638 26.828 37.1492 26.828 36.0209C26.828 34.8927 25.9133 33.978 24.7851 33.978C23.6568 33.978 22.7422 34.8927 22.7422 36.0209C22.7422 37.1492 23.6568 38.0638 24.7851 38.0638Z"
        fill="white"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_3635_34119"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(9.4921 38.2218) scale(29.3002)"
      >
        <stop stopColor="#3B6AF4" />
        <stop offset="1" stopColor="#19AEDF" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_3635_34119"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(9.4921 38.2218) scale(29.3002)"
      >
        <stop stopColor="#3B6AF4" />
        <stop offset="1" stopColor="#19AEDF" />
      </radialGradient>
      <clipPath id="clip0_3635_34119">
        <rect width="40" height="26.1512" fill="white" transform="translate(5 14.6665)" />
      </clipPath>
    </defs>
  </svg>
)

export default MoloLogo
